import type { SingletonBalancePosting } from '@festina/life-general-types/life'
import { typeUtils, type ValidatedKey } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikDoubleInput,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useCollectivePotsAccountTypes } from '../../hooks/useCollectivePotsAccountTypes'
import { useEnumOptions } from '../../hooks/useEnumOptions'
import { useHook } from '../../lenteHooks'

type Props = {
  fieldNamePrefix: ValidatedKey
  values: SingletonBalancePosting
  isReceiver?: boolean
}

export const AddBalancePostingFields = ({
  fieldNamePrefix,
  values,
  isReceiver,
}: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const validateKey =
    typeUtils.createNestedValidator<SingletonBalancePosting>(fieldNamePrefix)

  const accountTypes = useCollectivePotsAccountTypes({
    postingType: isReceiver ? values.postingType : undefined,
  })
  const postingTypes = useHook(
    'pages.collectivePots.useCollectivePotsPostingTypes',
  )({
    accountType: isReceiver ? undefined : values.accountType,
  })

  const dim1Options = useEnumOptions('TenantSubGroup')

  return (
    <>
      <FormikDatePicker
        label={translate('postings.column.valueDate')}
        name={validateKey('valueDate')}
        isRequired={!isReceiver}
        disabled={isReceiver}
      />
      <FormikSelect
        label={translate('postings.column.accountType')}
        name={validateKey('accountType')}
        options={accountTypes}
        isRequired
      />
      <FormikSelect
        label={translate('postings.column.postingType')}
        name={validateKey('postingType')}
        options={postingTypes}
        isRequired={!isReceiver}
        disabled={isReceiver}
      />
      <FormikDoubleInput
        label={translate('postings.column.amount')}
        name={validateKey('amount')}
        isRequired={!isReceiver}
        disabled={isReceiver}
      />
      <FormikSelect
        label={translate('postings.column.tenantSubGroup')}
        name={validateKey('dim1')}
        options={dim1Options}
        renderFn={(x) => translateEnum('life.enum.TenantSubGroup', x)}
        isRequired={!isReceiver}
        disabled={isReceiver}
      />
    </>
  )
}
